/**
 * Background Dots
 *
 * This is a vanilla-js script that fills the background
 * with nice moving dots.
 *
 */


const SPEED = 0.2


fillDots('background-dots')


function fillDots(id) {
  const balls: any = []

  const dots: any = document.getElementById(id)
  const width = dots.parentNode.offsetWidth
  const height = dots.parentNode.offsetHeight

  const nDots = Math.floor(width * height / 6000)

  for (let i = 0; i < nDots; i++) {
    const r = 1 + (Math.random() * 5)
    const opacity = 0.05 + (Math.random() * 0.15)
    const dot = makeNode('circle', {
      fill: 'rgba(255, 255, 255, ' + opacity + ')',
      r: r,
      cx: Math.random() * width,
      cy: Math.random() * height
    })

    dots.appendChild(dot)

    if (Math.random() < 0.2) {
      balls.push({
        el: dot,
        v: { x: Math.random() - 0.5, y: Math.random() - 0.5}
      })
    }

  }

  loop()

  function loop() {
    for (const ball of balls) {
      const { el, v } = ball

      const x0 = parseFloat(el.getAttribute('cx'))
      const y0 = parseFloat(el.getAttribute('cy'))

      const x = x0 + v.x * SPEED
      const y = y0 + v.y * SPEED

      if (x > width || x < 0) {
        v.x = -v.x
      }

      if (y > height || y < 0) {
        v.y = -v.y
      }

      el.setAttribute('cx', x)
      el.setAttribute('cy', y)
    }

    requestAnimationFrame(loop)
  }
}

function makeNode(type, values) {
  const node: any = document.createElementNS("http://www.w3.org/2000/svg", type)
  for (const key in values) {
    node.setAttributeNS(null, key, values[key])
  }
  return node
}


// WEBPACK FOOTER //
// ./src/background-dots.ts